import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/node_modules/next/dist/client/app-dir/link.js");
